// What any address with nothing at it shows, and what the operator-only pages
// show to everyone else.

import type { JSX } from "react";

export function NothingHere(): JSX.Element {
  return (
    <div className="page" style={{ minHeight: "100dvh", justifyContent: "center", textAlign: "center" }}>
      <p className="muted" style={{ margin: 0 }}>
        Nothing is at this address.
      </p>
      <a className="textlink" href="/">
        Go home
      </a>
    </div>
  );
}
